import { render, staticRenderFns } from "./CoozzySwitchButton.vue?vue&type=template&id=20aebcee&scoped=true"
import script from "./CoozzySwitchButton.vue?vue&type=script&lang=js"
export * from "./CoozzySwitchButton.vue?vue&type=script&lang=js"
import style0 from "./CoozzySwitchButton.vue?vue&type=style&index=0&id=20aebcee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aebcee",
  null
  
)

export default component.exports